export const EDITOR_ID = "editor";

export const CHANNEL_TYPE = Object.freeze({
  VIDEO: "video",
  AUDIO: "audio"
});

export const DEFAULT_CHANNEL_TYPE = CHANNEL_TYPE.VIDEO;

export const TIMELINE_UPDATE_INTERVAL = 1000;
export const STATISTIC_UPDATE_INTERVAL = 10000;

export const MEDIA_UPDATE_INTERVAL = 5000;

export const MEDIA_CONVERSION_STATUS = Object.freeze({
  READY: "ready",
  ENQUEUED: "enqueued",
  CONVERTING: "converting",
  POSTPROCESSING: "postprocessing",
  FAILED: "failed",
  REMOTE: "remote"
});

export const GIF_GENERATING_STATUS = Object.freeze({
  ENQUEUED: "enqueued",
  PREPARING: "preparing",
  RUNNING: "running",
  FAILED: "failed",
  DONE: "done",
  REMOTE: "remote"
});

export const isMediaStatusValid = status => {
  const availableStatuses = Object.values(MEDIA_CONVERSION_STATUS);
  return availableStatuses.includes(status);
};

export const SOCIAL_SHARING_STATUS = Object.freeze({
  READY: "ready",
  ENQUEUED: "enqueued",
  UPLOADING: "uploading",
  PROCESSING: "processing",
  ERROR: "failed",
});

export const isSharingStatusValid = status => {
  const availableStatuses = Object.values(SOCIAL_SHARING_STATUS);
  return availableStatuses.includes(status);
};

export const REMOVE_MEDIA_DIALOG_TYPE = Object.freeze({
  VIDEO: "video",
  ALL_VIDEOS: "all_videos",
  GIF: "gif",
  ALL_GIFS: "all_gifs",
  AUDIO: "audio",
  ALL_AUDIOS: "all_audios",
  UPLOAD: "upload"
});

export const EDIT_TYPE = Object.freeze({
  CROP: "crop",
  TRIM: "trim",
  CONCAT: "concat",
  AUDIO: "audio",
  TEXT: "text",
  TEMPLATES: "templates",
  MULTISTEPEDIT: "multistep"
});

export const SCALE_MODE = Object.freeze({
  CLOSE: "close",
  NEAR: "near",
  NORMAL: "normal",
  AWAY: "away",
  FARAWAY: "faraway"
});

export const isScaleModeValid = mode => {
  const availableModes = Object.values(SCALE_MODE);
  return availableModes.includes(mode);
};
